import { Link } from "react-router-dom";
import { timelineEvents } from "@/mocks/timeline";
import TimelineNode from "@/components/feature/TimelineNode";
import { SectionHeading } from "@/components/feature/PageHero";

export default function TimelinePreview() {
  const preview = timelineEvents.slice(0, 5);

  return (
    <section className="w-full border-y border-background-200 bg-background-100 px-4 py-12 md:px-6 md:py-16 lg:px-10">
      <SectionHeading
        title="事件时间线速览"
        description="从第一条内容出现，到关键材料补全，按时间顺序还原 511 爆料的完整脉络，每个节点都附带来源与核实状态。"
        action={{ label: "查看完整时间线", to: "/timeline" }}
      />

      <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
        <ol>
          {preview.map((event, index) => (
            <TimelineNode
              key={event.id}
              event={event}
              isLast={index === preview.length - 1}
            />
          ))}
        </ol>
        <div className="mt-5 border-t border-background-200 pt-5">
          <Link
            to="/timeline"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-secondary-100 px-4 py-2.5 text-sm font-medium text-secondary-900 transition-colors hover:bg-secondary-200"
          >
            还有 4 个节点与筛选工具
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-base"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}